import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { UiToastMessageService, UiTranslateLoaderService } from 'ui-shared';

@Component({
    selector: 'hr-galleria-extended',
    templateUrl: './hr-galleria-extended.component.html',
    styleUrls: ['hr-galleria-extended.component.scss'],
})
export class HrGalleriaExtendedComponent {
    @Input() images: any[] = [];
    @Input() addLabel: string;
    @Input() deleteLabel: string;
    @Input() showAsterisk: boolean = false;

    @Output() onSaveEvent = new EventEmitter<{ file: File; fileDescription: string }>();
    @Output() onDeleteEvent = new EventEmitter<number>();

    @ViewChild('fileInput') fileInput: FileUpload;

    uploadModal: boolean = false;
    fileDescription: string = '';
    imagesExist: boolean = false;
    file: File = null;

    constructor(
        private uiToastMessageService: UiToastMessageService,
        protected translateService: UiTranslateLoaderService,
    ) {}

    _activeIndex: number = 0;

    get activeIndex(): number {
        return this._activeIndex;
    }

    set activeIndex(newValue) {
        if (this.images && 0 <= newValue && newValue <= this.images.length - 1) {
            this._activeIndex = newValue;
        }
    }
    ngOnChanges() {
        this.sortImages();
    }

    ngOnInit(){
        this.sortImages();
    }

    private sortImages(){
        this.images.sort(
            (a,b)=>
                (new Date(a?.dateCreated ?? 0 ).getTime()) - (new Date(b?.dateCreated ?? 0).getTime())
        );
    }


    ngDoCheck(){
        this.sortImages();
    }
    onSave() {
        if (this.file != null) {
            if(this.showAsterisk && !this.fileDescription) {
                this.uiToastMessageService.showWarn(this.translateService.instant('hrGalleriaExtended.requiredFields'));
                return;
            }
            this.onSaveEvent.emit({ file: this.file, fileDescription: this.fileDescription });
            this.closeUploadModal();
        }else{
            this.uiToastMessageService.showWarn(this.translateService.instant('hrGalleriaExtended.requiredFields'));
            return;
        }
    }

    onDelete() {
        this.onDeleteEvent.emit(this._activeIndex);
    }

    removeFile() {
        this.file = null;
    }

    refreshGalleria() {
        if (this.images && this.images.length > 0) {
            this.imagesExist = true;
            this._activeIndex = this.images.length - 1;
        } else {
            this.imagesExist = false;
            this._activeIndex = 0;
        }
    }

    onShowUploadModal() {
        this.file = null;
        this.uploadModal = true;
    }

    closeUploadModal() {
        this.file = null;
        this.fileDescription = '';
        this.uploadModal = false;
        this.fileInput.clear();
    }

    selectFile(event: any) {
        this.file = event.files[0];
    }
}
